export const priceLensAbi = [
  {
    inputs: [{ name: 'vault', type: 'address' }],
    name: 'getVaultPrice',
    outputs: [
      {
        components: [
          { name: 'asset', type: 'address' },
          { name: 'unitOfAccount', type: 'address' },
          { name: 'unitOfAccountDecimals', type: 'uint8' },
          { name: 'amountOutMid', type: 'uint256' },
          { name: 'queryFailure', type: 'bool' },
        ],
        name: 'result',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ name: 'vaults', type: 'address[]' }],
    name: 'getVaultPrices',
    outputs: [
      {
        components: [
          { name: 'asset', type: 'address' },
          { name: 'unitOfAccount', type: 'address' },
          { name: 'unitOfAccountDecimals', type: 'uint8' },
          { name: 'amountOutMid', type: 'uint256' },
          { name: 'queryFailure', type: 'bool' },
        ],
        name: 'results',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const
